<template>
  <div id="app" class="container">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import "./css/layout.css";
export default {
  name: "App"
};
</script>

<style>
.el-dialog  .el-dialog__header{
  display: none !important;
}
.el-checkbox__original{
  width: 25px;
  height: 25px;
}
.el-radio__original{
  width: 20px;
  height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue